import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { login } from "../../helpers/api";
import { LOGIN } from "./actionTypes";
import { showToast } from "../toast/actions";
import Constant from "../../util/constant";


/**
 * Generator function that adds depots to the system.
 * @param {object} payload - The payload object containing the data and token.
 * @param {object} success - The success callback function.
 * @param {object} failure - The failure callback function.
 * @returns None
 */
function* loginUser({ payload: { data }, success, failure}){
  try {
    const response = yield call(login, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      window.localStorage.setItem(Constant.LOCALSTORAGEKEYS.LOGINROLE, response?.data?.role);
      window.localStorage.setItem(Constant.LOCALSTORAGEKEYS.ACCESSTOKEN, response?.data?.accesstoken);
      window.localStorage.setItem(Constant.LOCALSTORAGEKEYS.REFRESHTOKEN, response?.data?.refreshtoken);  
      success(response)
    }
  } catch (error) {
    failure(error)
  }
}





function* loginSaga() {
     yield takeEvery(LOGIN, loginUser);

}

export default loginSaga;
